import { gql } from '@lcs/shared/api';

export const deleteScheduleMutation = gql`
   mutation DeleteSchedule($scheduleId: UInt!) {
      deleteSchedule(id: $scheduleId)
   }
`;
